import React, { useState } from 'react'
import { Route, Switch, Link } from 'react-router-dom'

import Sidebar from '../components/menu'
import VendorSidebar from './vendor/menu'

import routes from './routes'

import { Layout, Menu, BackTop } from 'antd'
import {
  SettingOutlined,
  UserOutlined,
  KeyOutlined,
  LogoutOutlined
} from '@ant-design/icons'

import CheckUpdates from '../core/components/widget/update'
import CommonUnkownError from './common/error/error'

import { LAYOUT_COMMON_USER_CHANGE_PASSWORD } from './common/navigation'
import { LAYOUT_ADMIN_PANEL } from './admin/navigation'
import { LAYOUT_MANAGER_USER_SHOW } from './manager/navigation'
import { LAYOUT_VENDOR_USER_SHOW } from './vendor/navigation'

import MarcaBlanco from '../assets/imgs/marca-blanco.png'
import MarcaNegro from '../assets/imgs/marca-negro.png'
import { useTheme } from '../hooks/useTheme'
import {
  useUserSession,
  isGrantedSome,
  getUserRoles
} from '../hooks/useUserSession'

const { Header, Sider, Content } = Layout
const { SubMenu } = Menu

const CustomSidebar = (props) => {
  const {
    collapsed,
    collapsedWidth,
    setCollapsedWidth,
    setBroken,
    broken,
    onCollapse,
    paddingTop
  } = props
  const { darkMenu } = props.theme

  return (
    <Sider
      theme={darkMenu === 'true' ? 'dark' : 'light'}
      breakpoint='lg'
      collapsedWidth={collapsedWidth}
      onBreakpoint={(broken) => {
        if (broken) {
          setBroken(true)
          setCollapsedWidth(0)
        } else {
          setBroken(false)
          setCollapsedWidth(60)
        }
      }}
      onCollapse={onCollapse}
      collapsible
      defaultCollapsed
      collapsed={collapsed}
      style={{
        verflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        paddingTop
      }}
    >
      {!isGrantedSome(['ROLE_TYPE_VENDOR'], props.roles) && (
        <Sidebar {...props} routes={routes} />
      )}
      {isGrantedSome(['ROLE_TYPE_VENDOR'], props.roles) && (
        <VendorSidebar {...props} routes={routes} />
      )}
    </Sider>
  )
}

const CustomHeader = (props) => {
  const { collapsed, collapsedWidth, onCollapse, addPaddingTop } = props
  const { data } = props
  const { darkHeader } = props.theme
  const toggle = () => onCollapse(!collapsed, 'header')

  return (
    <Header
      className='ite-layout-background'
      style={{
        padding: 0,
        position: 'fixed',
        zIndex: 10,
        width: props.width,
        height: props.height
      }}
    >
      <CheckUpdates addPaddingTop={addPaddingTop} />
      <div className='logo'>
        <img
          src={darkHeader === 'true' ? MarcaBlanco : MarcaNegro}
          width={150}
          onClick={toggle}
          alt='logo'
        />
      </div>

      <Menu
        theme={darkHeader === 'true' ? 'dark' : 'light'}
        mode='horizontal'
        style={{ display: 'block' }}
      >
        <SubMenu
          key='user-menu'
          style={{ float: 'right' }}
          icon={<UserOutlined />}
          title={data && data.user && data.user.first_name ? data.user.first_name : 'User'}
          placement='bottomRight'
        >
          {!isGrantedSome(['ROLE_TYPE_VENDOR'], props.roles) && (
            <Menu.Item key='user:profile' icon={<UserOutlined />}>
              <Link to={LAYOUT_MANAGER_USER_SHOW}>Profile</Link>
            </Menu.Item>
          )}

          {isGrantedSome(['ROLE_TYPE_VENDOR'], props.roles) && (
            <Menu.Item key='user:profile' icon={<UserOutlined />}>
              <Link to={LAYOUT_VENDOR_USER_SHOW}>Profile</Link>
            </Menu.Item>
          )}

          <Menu.Item key='user:change-password' icon={<KeyOutlined />}>
            <Link to={LAYOUT_COMMON_USER_CHANGE_PASSWORD}>Change password</Link>
          </Menu.Item>
          <Menu.Item key='user:logout' icon={<LogoutOutlined />}>
            <Link to='/auth/login'>Log out</Link>
          </Menu.Item>
        </SubMenu>
        {isGrantedSome(['ROLE_MANAGER_ADMIN'], props.roles) && (
          <Menu.Item
            key='setting'
            icon={<SettingOutlined />}
            style={{ float: 'right' }}
          >
            <Link to={LAYOUT_ADMIN_PANEL} />
          </Menu.Item>
        )}
      </Menu>
    </Header>
  )
};

CustomHeader.defaultProps = {
  width: '100%'
}

const CustomContent = (props) => {
  const getRoutes = (routes) => {
    const allowRoutes = routes.map((prop, key) => {
      if (prop.allowToOneOf && isGrantedSome(prop.allowToOneOf, props.roles)) {
        return <Route path={prop.path} component={prop.component} key={key} />
      } else {
        return null
      }
    })

    return allowRoutes
  };

  return (
    <Content>
      <div style={{ paddingTop: 20, paddingLeft: 10, paddingRight: 10 }}>
        <Switch>{getRoutes(routes)}</Switch>
      </div>
    </Content>
  )
}

CustomContent.defaultProps = {}

const MainLayout = (props) => {
  const { data: theme, isLoading: isLoadingTheme, isError: isThemeError } = useTheme()
  const {
    data: information,
    isLoading: isLoadingInformation,
    isError: isInformationError
  } = useUserSession()

  const [first, setFirst] = useState(true)
  const [broken, setBroken] = useState(false)
  const [collapsed, setCollapsed] = useState(true)
  const [collapsedWidth, setCollapsedWidth] = useState(60)
  const [paddingTop, setPaddingTop] = useState(50)
  const [headerHeight, setHeaderHeight] = useState(50)

  const addPaddingTop = (n) => {
    setPaddingTop(50 + n)
    setHeaderHeight(50 + n)
  }

  const onCollapse = (collapsed, type) => {
    if (first) {
      setFirst(false)
    } else {
      setCollapsed(collapsed)
    }
  }

  if (isLoadingTheme || isLoadingInformation) return null
  if (isThemeError || isInformationError) return null // (<CommonUnkownError />)

  const roles = getUserRoles()

  const cmarginLeft = broken && collapsed ? 0 : collapsed ? 60 : 200

  return (
    <Layout>
      <CustomHeader
        height={headerHeight}
        width='100%'
        collapsed={collapsed}
        onCollapse={onCollapse}
        collapsedWidth={collapsedWidth}
        addPaddingTop={addPaddingTop}
        theme={theme}
        data={information}
        roles={roles}
      />

      <Layout
        hasSider
        className='site-layout'
        style={{
          marginLeft: cmarginLeft,
          padding: '0px 16px 0',
          paddingTop,
          minHeight: '100vh'
        }}
      >
        <CustomSidebar
          collapsed={collapsed}
          collapsedWidth={collapsedWidth}
          setCollapsedWidth={setCollapsedWidth}
          onCollapse={onCollapse}
          setBroken={setBroken}
          paddingTop={paddingTop}
          theme={theme}
          data={information}
          roles={roles}
        />

        <CustomContent theme={theme} data={information} roles={roles} />
      </Layout>
      <BackTop />
    </Layout>
  )
}

export default MainLayout
